// extracted by mini-css-extract-plugin
export default {"infoTooltipBlock":"InfoBtnControl_infoTooltipBlock__L7Jky","printTechnicTooltip":"InfoBtnControl_printTechnicTooltip__yy46K"};